export * from './prizmIcons-triangle-down.icon';
